// extracted by mini-css-extract-plugin
export default {"chatbox":"ChatInput_chatbox__GJcnA","button":"ChatInput_button__bQbDW"};